import React from 'react';
import { getInfreaestructureById, getReadingsV2 } from '@/services/measurement';
import {
	MapModeStrategy,
	Infrastructure,
	PopupData,
	FetchParams,
	MapModeContext,
	DigitalTwinContext,
} from './MapModeStrategy';

const PopupComponent = React.lazy(() => import('../Popup.jsx'));

class SewerAnalysisModeStrategy implements MapModeStrategy {
	name = 'sewerAnalysis';
	displayName = 'Sewer Analysis';
	dragRotate = true;
	touchRotate = true;

	filterInfrastructures(
		infras: Infrastructure[],
		context: MapModeContext,
		selectedTypes: string[],
	): Infrastructure[] {
		if (!infras) return [];

		return infras.filter((infra) => selectedTypes.includes(infra.infrastructureTypeName));
	}

	calculateOpacities(
		infras: Infrastructure[],
		context: MapModeContext,
		digitalTwinContext?: DigitalTwinContext,
	): Record<number, number> {
		const opacities: Record<number, number> = {};
		if (!infras) return opacities;

		infras.forEach((infra) => {
			opacities[infra.measurementeInfraestructureId] = 1.0;
		});

		return opacities;
	}

	async handleAssetClick(
		infra: Infrastructure,
		context: MapModeContext,
	): Promise<PopupData> {
		const mt = infra.mainMeasurementTarget;
		try {
			const [response, readingsData] = await Promise.all([
				getInfreaestructureById(infra.measurementeInfraestructureId),
				mt?.measurementTargetId
					? getReadingsV2(mt.measurementTargetId)
					: Promise.resolve(null),
			]);

			if (response) {
				return {
					...response,
					expired: mt?.expired,
					prefetchedReadings: readingsData,
				};
			}

			return {
				measurementeInfraestructureId: infra.measurementeInfraestructureId,
				measurementInfraestructureName: infra.measurementInfraestructureName,
				infrastructureTypeName: infra.infrastructureTypeName,
				expired: mt?.expired,
			};
		} catch (error) {
			console.error('Error fetching infrastructure data:', error);

			return {
				measurementeInfraestructureId: infra.measurementeInfraestructureId,
				measurementInfraestructureName: infra.measurementInfraestructureName,
				infrastructureTypeName: infra.infrastructureTypeName,
				expired: mt?.expired,
			};
		}
	}

	PopupComponent = PopupComponent;

	getFetchParams(context: MapModeContext): FetchParams {
		return {
			mode: '',
		};
	}

	getHighlightedAssets(
		context: MapModeContext,
		digitalTwinContext?: DigitalTwinContext,
	): Set<number> | null {
		return null;
	}

	getPopupProps(
		infraInfo: PopupData,
		context: MapModeContext,
		additionalData?: any,
	): Record<string, any> {
		return {
			data: infraInfo,
			id: infraInfo.measurementeInfraestructureId,
		};
	}
}

export const sewerAnalysisModeStrategy = new SewerAnalysisModeStrategy();
export default SewerAnalysisModeStrategy;
